<template>
  <div style="max-height: 400px;">
    <div style="height: 10px"></div>
    <el-form size="small" :model="clockForm" :rules="clockRules" ref="clockForm" label-width="80px" class="demo-ruleForm">
      <el-row>
        <el-col :span="8">
          <el-form-item label="提醒类型" prop="type">
            <el-select v-fixZoom style="width: 180px" v-model="clockForm.type" placeholder="请选择">
              <el-option v-for="item in clockContentTypeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="提醒周期" prop="period">
            <el-select v-fixZoom style="width: 180px" v-model="clockForm.period" placeholder="请选择">
              <el-option v-for="item in clockPeriodModelArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="提醒时间" prop="time">
            <el-date-picker v-fixZoom
              v-if="clockForm.period === 'y'"
              v-model="clockForm.time"
              type="datetime"
              placeholder="选择日期时间"
              format="MM-dd HH:mm:ss"
              value-format="MM-dd HH:mm:ss"
              style="width: 180px">
            </el-date-picker>
            <el-date-picker v-fixZoom
              v-if="clockForm.period === 'm'"
              v-model="clockForm.time"
              type="datetime"
              placeholder="选择日期时间"
              format="dd HH:mm:ss"
              value-format="dd HH:mm:ss"
              style="width: 180px">
            </el-date-picker>
             <el-time-picker v-fixZoom
              v-if="clockForm.period === 'd'"
              v-model="clockForm.time"
              placeholder="选择日期时间"
              value-format="HH:mm:ss"
              style="width: 180px">
            </el-time-picker>
            <el-date-picker v-fixZoom
              v-if="clockForm.period === 's'"
              v-model="clockForm.time"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="clockForm.type === 'other'" label="提醒内容" prop="content">
        <el-input style="width: 747px" type="textarea" :rows="4" placeholder="请输入提醒内容" v-model="clockForm.content" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: right;padding: 10px 20px 20px 0">
      <el-button @click="closeOpen()">取 消</el-button>
      <el-button type="primary" @click="submitClock('clockForm')">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addEditClock',
  model: {
    prop: 'addEditClockShow',
    event: 'change'
  },
  props: {
    addEditClockObj: {
      type: Object
    }
  },
  data () {
    return {
      clockPeriodModelArr: [{name: '按年', id: 'y'}, {name: '按月', id: 'm'}, {name: '按天', id: 'd'}, {name: '只提醒一次', id: 's'}],
      clockContentTypeArr: [{name: '吃药提醒', id: 'pill'}, {name: '量血压', id: 'BP'}, {name: '测体温', id: 'Temp'}, {name: '测血糖', id: 'GLU'}, {name: '体检', id: 'PE'}, {name: '其它', id: 'other'}],
      clockForm: {
        no: '',
        content: '',
        period: 'y',
        time: '',
        type: ''
      },
      clockRules: {
        type: [
          { required: true, message: '请选择提醒类型', trigger: 'change' }
        ],
        period: [
          { required: true, message: '请选择提醒周期', trigger: 'change' }
        ],
        time: [
          { required: true, message: '请选择提醒时间', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入提醒内容', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.addEditClockObj.isAdd) {
      this.clockForm.content = ''
      this.clockForm.period = 'y'
      this.clockForm.time = ''
      this.clockForm.type = ''
    } else {
      this.clockForm.no = this.addEditClockObj.row.no
      this.clockForm.period = this.addEditClockObj.row.period
      this.clockForm.time = this.addEditClockObj.row.time
      if (this.addEditClockObj.row.content === 'pill' || this.addEditClockObj.row.content === 'BP' || this.addEditClockObj.row.content === 'Temp' || this.addEditClockObj.row.content === 'GLU' || this.addEditClockObj.row.content === 'PE') {
        this.clockForm.type = this.addEditClockObj.row.content
      } else {
        this.clockForm.type = 'other'
        this.clockForm.content = this.addEditClockObj.row.content
      }
    }
  },
  methods: {
    submitClock (formName) {
      console.log(this.clockForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.clockForm.type !== 'other') {
            this.clockForm.content = this.clockForm.type
          }
          this.$emit('getFather', this.clockForm)
          this.$emit('change', false)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeOpen () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemlog/childComponents/addEditClock.vue